<template>
  <div class="main-container">
    <NavbarComponent
      :mobileView="false"
      :hide-button="IsOnAssetBoardClientViewMode || !showContent"
      v-if="!IsOnAssetBoardClientViewMode" />
    <div v-if="showContent && !IsOnAssetBoardClientViewMode">
      <WelcomeUser v-if="showContent" :mobileView="false" />
      <StatusBar />
      <b-card no-body>
        <b-tabs card class="content-bg">
          <b-tab
            v-for="tab in filteredTabs()"
            :lazy="tab.lazy"
            :key="tab.id"
            :title="tab.title"
            :active="tab.active"
            :title-link-class="tab.class"
            :title-link-attributes="{
              href: $router.resolve('/' + tab.path).href
            }"
            @click="tabChanged(tab)">
            <template #title>
              <b-icon :icon="tab.icon" :title="tab.title"></b-icon>
              {{ tab.title }}
            </template>
            <component
              :is="tab.component"
              :errorMessage="tab.message || ''"
              :mobileView="false" />
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
    <div v-if="showContent && IsOnAssetBoardClientViewMode">
      <AssetBoard :mobileView="false" />
    </div>
    <div v-if="!showContent && !IsOnAssetBoardClientViewMode">
      <StatusBar />
      <AdBanner />
    </div>
    <div v-if="!showContent && !IsOnAssetBoardClientViewMode">
      <About :errorMessage="errorMessage" />
    </div>
  </div>
</template>

<script>
import Services from '../services/main.service.vue'
import NavbarComponent from '../components/Navbar.vue'
import AdBanner from '../components/AdBanner.vue'
import About from '../components/About.vue'
import WelcomeUser from '../components/WelcomeUser.vue'
import StatusBar from '../components/StatusBar.vue'
import HomePanel from '../components/home'
import HolidayLogs from '../components/logs-components/Holiday/Main.vue'
import ExpenseLogs from '../components/logs-components/ExpenseLogs.vue'
import StaffingLogs from '../components/logs-components/StaffingLogs.vue'
import TimeLogs from '../components/logs-components/TimeLogs.vue'
import Staffing from '../components/admin/Staffing.vue'
import AssetBoard from '../components/admin/AssetBoard.vue'
import ProjectsTracker from '../components/admin/ProjectsTracker.vue'
import Reports from '../components/reports-components/Reports.vue'
import Admin from '../components/admin/Admin.vue'
import Beta from '../components/Beta.vue'
import SuperAdmin from '../components/superadmin/SuperAdmin.vue'

export default {
  name: 'HomePage',
  components: {
    NavbarComponent,
    AdBanner,
    About,
    WelcomeUser,
    StatusBar,
    HomePanel,
    HolidayLogs,
    ExpenseLogs,
    TimeLogs,
    StaffingLogs,
    Staffing,
    AssetBoard,
    ProjectsTracker,
    Reports,
    Admin,
    Beta,
    SuperAdmin
  },
  data() {
    return {
      errorMessage: '',
      showContent: false,
      showReportContent: false,
      showAdminContent: false,
      showAdminTabs:
        this?.$store?.getters?.showAdminTabs ??
        process?.env?.VUE_APP_SHOW_ADMIN_TABS ??
        true,
      env:
        this?.$store?.getters?.appEnv ??
        process?.env?.VUE_APP_ENV ??
        'production',
      assetBoardTab: {},
      tabs: [
        // add uri path to each tab here
        {
          id: 'tab_timesheet',
          path: 'not-active',
          component: 'about',
          title: 'Timesheet',
          icon: 'info-circle',
          message:
            'Your account is not active, Please ask administrator to activate it.',
          class: '',
          lazy: true,
          active: false,
          show: false
        },
        {
          id: 'tab_home_panel',
          path: '',
          component: 'home-panel',
          icon: 'house-door',
          title: 'Home',
          class: 'lizard-tab',
          lazy: true,
          active: false,
          show: false
        },
        {
          id: 'tab_staffing_logs',
          path: 'staffing',
          component: 'staffing-logs',
          icon: 'calendar3',
          title: 'My Staffing',
          class: 'lizard-tab',
          lazy: true,
          active: false,
          show: false
        },
        {
          id: 'tab_expenses',
          path: 'expenses',
          component: 'expense-logs',
          title: 'My Expenses',
          icon: 'wallet2',
          class: 'lizard-tab',
          lazy: true,
          active: false,
          show: false
        },
        {
          id: 'tab_holidays',
          path: 'leaves',
          component: 'holiday-logs',
          icon: 'emoji-sunglasses',
          title: 'My Leave',
          class: 'lizard-tab',
          lazy: true,
          active: false,
          show: false
        },
        {
          id: 'tab_timelogs',
          path: 'timesheet',
          component: 'time-logs',
          icon: 'clock',
          title: 'My Timesheet',
          class: 'lizard-tab',
          lazy: true,
          active: false,
          show: false
        },
        {
          id: 'tab_staffing',
          path: 'staffing-panel',
          component: 'staffing',
          icon: 'people',
          title: 'Staffing',
          class: 'lizard-tab',
          lazy: true,
          active: false,
          show: false
        },
        {
          id: 'tab_assetboard',
          path: 'assetboard',
          component: 'asset-board',
          icon: 'kanban',
          title: 'Asset Board',
          class: 'lizard-tab',
          lazy: true,
          active: false,
          show: false
        },
        {
          id: 'tab_projects_tracker',
          path: 'projects-tracker',
          component: 'projects-tracker',
          icon: 'calculator',
          title: 'Project Cost Tracker',
          class: 'lizard-tab',
          lazy: true,
          active: false,
          show: false
        },
        {
          id: 'tab_reports',
          path: 'reports',
          component: 'reports',
          icon: 'bar-chart-line',
          title: 'Reports',
          class: 'lizard-tab',
          lazy: true,
          active: false,
          show: false
        },
        {
          id: 'tab_beta',
          path: 'beta',
          component: 'beta',
          icon: 'cpu',
          title: 'BETA',
          class: 'lizard-tab',
          lazy: true,
          active: false,
          show: false
        },
        {
          id: 'tab_admin',
          path: 'admin',
          component: 'admin',
          icon: 'sliders',
          title: 'Admin',
          class: 'lizard-tab',
          lazy: true,
          active: false,
          show: false
        },
        {
          id: 'tab_superadmin',
          path: 'super-admin',
          component: 'super-admin',
          icon: 'shield-shaded',
          title: 'SuperAdmin',
          class: 'lizard-tab',
          lazy: true,
          active: false,
          show: false
        }
      ],
      selectedTab: 'tab_home_panel',
      notifSent: []
    }
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    UserData() {
      return this.Store.userAuth
    },
    IsAuthenticated() {
      return this.UserData.authenticated
    },
    HasAdminPerm() {
      return this.UserData.hasAdminPrivileges
    },
    HasManagerPerm() {
      return this.UserData.hasManagerPrivileges
    },
    IsOnAssetBoardClientViewMode() {
      return this.Store.assetBoardClientView
    },
    Path() {
      return this.$route.path
    }
  },
  mounted() {
    this.$root.$on('service-status', (isAvailable) => {
      this.toastNotif = null
      setTimeout(() => {
        if (!isAvailable) {
          this.fireNetworkNotif(false)
        }
      }, 500)
    })
    this.$root.$on('network-status', (isOnine, errMessage) => {
      this.toastNotif = null
      setTimeout(() => {
        if (!isOnine) {
          this.fireNetworkNotif(false, errMessage)
        }
      }, 500)
    })
    this.$root.$on('fireLoginNotif', () => {
      if (!this.notifSent.includes('fireLoginNotif')) {
        setTimeout(() => {
          this.fireLoginNotif(false)
        }, 2000)
      }
    })
    this.$root.$on('fire403Notif', () => {
      setTimeout(() => {
        this.fire403Notif(false)
      }, 2000)
    })
  },
  methods: {
    userLoaded(user) {
      try {
        this.showContent = user?.authenticated ?? false
        // Derived from the store rather than the old __auth-data cookie, which
        // the MSAL flow used to write and nothing sets any more. The store's
        // flag comes from the user's portal role, which is also what
        // HasAdminPerm below already uses — so the two can no longer disagree.
        const isAdmin = user?.hasAdminPrivileges ?? false
        this.showReportContent = isAdmin
        this.showAdminContent = isAdmin && this.showAdminTabs
        if (user) {
          const userRole = (
            user?.details?.app?.roleLabel ?? 'not_specified'
          ).toLowerCase()
          const userTabs = user?.details?.app?.tabsToShow ?? []
          this.tabs = this.tabs.map((tab) => {
            const tabLabel = tab.id.split('_').splice(1).join('_')
            tab.show = userTabs.includes(tabLabel) ?? false
            tab.active = false
            return tab
          })
          setTimeout(() => {
            const tabIndex = this.tabs.findIndex(
              (tab) => tab.path === this.Path.substr(1)
            )
            let selectedTab = this.tabs[tabIndex]
            if (selectedTab.show) {
              this.tabs[tabIndex].active = true
              this.selectedTab = selectedTab.id
            } else {
              this.selectedTab = 'tab_home_panel'
              selectedTab = this.tabs.find((tab) => tab.id === 'tab_home_panel')
            }
            this.tabChanged(selectedTab)
          }, 500)
        }
      } catch (exception) {
        console.log(exception)
      }
    },
    assetBoardClientViewHandler(current, prev) {
      if (!current && prev) {
        this.selectedTab = 'tab_assetboard'
      }
    },
    filteredTabs() {
      return this.tabs
        .filter((tab) => {
          return tab.show
        })
        .map((tab) => {
          tab.active = tab.id === this.selectedTab
          return tab
        })
    },
    tabChanged(tab) {
      // check user is still logged in
      Services.Users.fetchCurrentUser()
        .then(({ status, data }) => {
          this.authorizingToastActive = false
          // if (status !== 200) {
          //   this.$root.$emit('user-signed-out')
          // }
          this.$store.commit(
            'updateNotifications',
            data?.content?.notifications ?? {}
          )
        })
        .catch(() => {
          // this.$root.$emit('user-signed-out')
        })
    },
    closeClientView() {
      this.$store.commit('setAssetBoardClientView', false)
    },
    fireNetworkNotif(
      success = true,
      errMessage = 'Timesheet service is not available right now. Please try again later.'
    ) {
      if (!this.notifSent.includes(`fireNetworkNotif:${success}`)) {
        this.notifSent.push(`fireNetworkNotif:${success}`)
        this.$toasted[success ? 'success' : 'error'](
          success ? 'Timesheet service is available!' : errMessage
        ).goAway(success ? 2000 : 20000)
      }
    },
    fireLoginNotif() {
      if (this.showContent) {
        return
      }
      this.notifSent.push('fireLoginNotif')
      return this.$toasted
        .info('Please sign-in using your Candesic account.')
        .goAway(1500)
    },
    fire403Notif() {
      this.errorMessage =
        'Your account is not active, Please ask administrator to activate it.'
      this.notifSent.push('fire403Notif')
      return this.$toasted.info(this.errorMessage).goAway(1500)
    },
    isPrd() {
      return ['staging', 'development'].indexOf(this.env) === -1
    },
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    },
    tabSelected(currentTab, prevTab) {
      if (currentTab === 'tab_home_panel' && prevTab === 'tab_assetboard') {
        this.selectedTab = prevTab
        return
      }
    }
  },
  watch: {
    UserData: {
      handler: 'userLoaded',
      deep: true,
      immediate: true
    },
    IsOnAssetBoardClientViewMode: {
      handler: 'assetBoardClientViewHandler',
      deep: true,
      immediate: true
    },
    selectedTab: {
      handler: 'tabSelected',
      deep: true,
      immediate: true
    }
  }
}
</script>

<style>
.main-container {
  min-height: calc(100vh - 100px) !important;
}
.card {
  background: rgba(245, 244, 239, 0.9) !important;
  border-radius: 0 !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid rgba(245, 244, 239, 0.4) !important;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  transition: all 0.3s ease;
}

.card-header {
  border-radius: 0 !important;
  background: rgba(245, 244, 239, 0.95) !important;
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.07) !important;
  padding: 0.7rem 1.25rem !important;
}

/* Main tab bar, under the welcome banner. These selectors are deliberately
   global: the admin, reports and superadmin sections use b-tabs too and take
   their look from here. */
ul.nav-tabs {
  border-bottom: none !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center !important;
  /* Column gap is tighter than the row gap so a wrapped second row reads as a
     separate line rather than a run-on of the first. */
  gap: 8px 4px;
  margin-bottom: 0 !important;
}

ul.nav-tabs > .nav-item {
  margin-bottom: 0 !important;
}

/* One size for every tab. The size used to depend on whether a tab carried
   the .lizard-tab class, which left the odd one out a step smaller. */
ul.nav-tabs > .nav-item .nav-link {
  font-size: 0.875rem !important;
  font-weight: 600 !important;
  letter-spacing: -0.01em;
  color: #64748b !important;
  margin: 0 !important;
  padding: 0.5rem 0.85rem !important;
  border-radius: 8px !important;
  border: 1px solid transparent !important;
  background: transparent !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  vertical-align: middle !important;
  white-space: nowrap;
  gap: 7px !important;
  transition:
    color 0.2s ease,
    background-color 0.2s ease,
    box-shadow 0.2s ease !important;
}

ul.nav-tabs > .nav-item .nav-link svg,
ul.nav-tabs > .nav-item .nav-link i,
ul.nav-tabs > .nav-item .nav-link .bi {
  margin: 0 !important;
  vertical-align: middle !important;
  /* Icons sit back a little so the labels lead, then come forward on the
     active tab. */
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

ul.nav-tabs > .nav-item .nav-link:hover {
  color: #0073be !important;
  background-color: rgba(0, 115, 190, 0.08) !important;
  border-color: transparent !important;
}

ul.nav-tabs > .nav-item .nav-link:hover svg,
ul.nav-tabs > .nav-item .nav-link.active svg {
  opacity: 1;
}

ul.nav-tabs > .nav-item .nav-link:focus-visible {
  outline: none !important;
  box-shadow: 0 0 0 3px rgba(0, 115, 190, 0.25) !important;
}

ul.nav-tabs > .nav-item .nav-link.active {
  color: #ffffff !important;
  font-weight: 700 !important;
  background: linear-gradient(135deg, #0073be 0%, #1d9ce5 100%) !important;
  border-color: transparent !important;
  box-shadow: 0 2px 8px rgba(0, 115, 190, 0.28) !important;
}

ul.nav-pills > .nav-item .nav-link {
  font-size: 0.95rem !important;
  font-weight: 500 !important;
  color: #4b5563 !important;
  padding: 0.5rem 1rem !important;
  border-radius: 6px !important;
  transition: all 0.2s ease !important;
}

ul.nav-pills > .nav-item .nav-link:hover {
  background-color: rgba(0, 115, 190, 0.08) !important;
  color: #0073be !important;
}

ul.nav-pills > .nav-item .nav-link.active {
  background-color: #0073be !important;
  color: #fff !important;
  font-weight: 600 !important;
  box-shadow: 0 4px 10px rgba(0, 115, 190, 0.2) !important;
}
</style>
